import React from "react";
import AppHeading from "../layout/parts/app-heading";
import AppBody from "../layout/parts/app-body";
import Card from "../components/card";
import SimpleInfoBlock from "../components/graphs/simple-info-block";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import LineChart from "../components/graphs/line-chart";
import axios, { responseHandler, errorHandler } from "../requests/axios.js";
import ListChart from "../components/graphs/list-chart.jsx";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";
import LiveTvRoundedIcon from "@mui/icons-material/LiveTvRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import TvRoundedIcon from "@mui/icons-material/TvRounded";
import WcRounded from "@mui/icons-material/WcRounded";

import { subDays } from "date-fns";
import { toast } from "react-toastify";
import dateToYmd from "../functions/date-to-ymd.js";

export default function OverviewPage() {
  const [loading, setLoading] = React.useState(false);
  const [allChartData, setChartData] = React.useState({});

  React.useEffect(() => {
    setLoading(true);

    const payload = {
      start_date: dateToYmd(subDays(new Date(), 30)),
      end_date: dateToYmd(new Date()),
    };

    axios
      .get(
        `api/pages/dashboard?start_date=${payload.start_date}&end_date=${payload.end_date}`
      )
      .then(
        responseHandler((response) => {
          setChartData(response.data);
        })
      )
      .catch(
        errorHandler((e) => {
          console.error(e);
          toast.error("Error loading data for the last 30 days");
        })
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <React.Fragment>
      <AppHeading
        subtitle={
          "Welcome back, lets see how your channels have been doing over the last 30 days"
        }
      />

      <AppBody loading={loading}>
        <div className="overview-page">
          <div className="overview-page__header-row">
            <SimpleInfoBlock
              label="Total Impressions"
              data={allChartData.impressions}
              icon={<VisibilityRoundedIcon />}
            />
            <SimpleInfoBlock
              label="Opportunities"
              data={allChartData.opportunities}
              icon={<BarChartRoundedIcon />}
            />
            <SimpleInfoBlock
              label="Engaged Sessions"
              data={allChartData.engaged_sessions}
              icon={<LiveTvRoundedIcon />}
            />
            <SimpleInfoBlock
              label="Engaged Viewers"
              data={allChartData.engaged_viewers}
              icon={<FavoriteBorderRoundedIcon />}
            />
          </div>
          <div className="overview-page__body">
            <div className="overview-page__left">
              <Card height={400}>
                <LineChart
                  title="Minutes Watched by Channel"
                  subtitle=""
                  datasets={allChartData.channels_minutes?.datasets || []}
                />
              </Card>
              <Card height={400}>
                <LineChart
                  title="Impressions by Channel"
                  subtitle=""
                  datasets={allChartData.channel_impressions?.datasets || []}
                />
              </Card>
            </div>
            <div className="overview-page__right">
              <Card>
                <ListChart
                  title="Device Breakdown"
                  subtitles={["Top Devices"]}
                  datasets={allChartData?.top_devices || []}
                  icons={[<TvRoundedIcon />]}
                />
              </Card>
              <Card>
                <ListChart
                  title="Region Breakdown"
                  subtitles={["Top Regions"]}
                  datasets={allChartData?.top_regions || []}
                  icons={[<PublicRoundedIcon />]}
                />
              </Card>
              <Card>
                <ListChart
                    title="Viewers"
                    subtitles={["Viewer behaviour"]}
                    z={console.log(allChartData?.viewer_behaviour?.datasets)}
                    datasets={allChartData?.viewer_behaviour || []}
                    icons={[<WcRounded />]}
                />
              </Card>
            </div>
          </div>
        </div>
      </AppBody>
    </React.Fragment>
  );
}
